import { clsx, type ClassValue } from 'clsx';

/** Joins class names; the one helper every component uses for conditional classes. */
export const cn = (...values: ClassValue[]): string => clsx(values);
